import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { EnvironmentService } from '../../service/service.module';

@Injectable({
  providedIn: 'root'
})
export class DataModuleService {
  
  environment = EnvironmentService.environment;

  constructor(private httpClient: HttpClient) { }

  fetchFileDataById(fileName: string, userId: string, page: number = 1,
    faulty: boolean = false, blanks: boolean = false, duplicates: boolean = false,
    outliers: boolean = false, exceptions: boolean = false, version: string | null = '0', valid: boolean = false) {
    return this.httpClient.get(`${this.environment.FileManagementURL}/user-data-upload/?user_id=${userId}&file_name=${fileName}&page=${page}&faulty=${faulty}&blanks=${blanks}&duplicate=${duplicates}&outliers=${outliers}&exceptions=${exceptions}&version=${version}&valid_data=${valid}`);
  }

  deleteSelectedRows(obj = {}) {
    return this.httpClient.post(`${this.environment.FileManagementURL}/delete-user-file-data/`, obj);
  }

  fetchCorrelationMatrix(fileName: string, userId: number, versionNo = 0) {
    return this.httpClient.get(`${this.environment.FileManagementURL}/file-correlation-data/?file_name=${fileName}&user_id=${userId}&version_no=${versionNo}`)
  }

  updateCorrelationValue(obj = {}) {
    return this.httpClient.post(`${this.environment.FileManagementURL}/file-correlation-data/`, obj)
  }

  fetchSummaryStats(fileName: string, userId: number, versionNo = 0) {
    return this.httpClient.get(`${this.environment.FileManagementURL}/file-summary-statistics/?file_name=${fileName}&user_id=${userId}&version_no=${versionNo}`)
  }

  resetToOriginal(obj = {}) {
    return this.httpClient.post(`${this.environment.FileManagementURL}/reset-to-original/`, obj);
  }

  replaceBlanksWithZeros(obj = {}) {
    return this.httpClient.post(`${this.environment.FileManagementURL}/replace-blanks/`, obj);
  }

  saveExceptionRules(obj = {}) {
    return this.httpClient.post(`${this.environment.FileManagementURL}/manage-exceptions/`, obj);
  }

  fetchExceptionRules(fileName: string, userId: number, versionNo = 0) {
    return this.httpClient.get(`${this.environment.FileManagementURL}/manage-exceptions/?file_name=${fileName}&user_id=${userId}&version_no=${versionNo}`);
  }

  saveTransformationRules(obj = {}) {
    return this.httpClient.post(`${this.environment.FileManagementURL}/manage-transformation/`, obj);
  }

  fetchTransformationRules(fileName: string, userId: number, versionNo = 0) {
    return this.httpClient.get(`${this.environment.FileManagementURL}/manage-transformation/?file_name=${fileName}&user_id=${userId}&version_no=${versionNo}`);
  }

  updateGridData(obj = {}) {
    return this.httpClient.put(`${this.environment.FileManagementURL}/user-data-upload/`, obj);
  }

  fetchOutliersData(fileName: string, userId: number, versionNo = 0) {
    return this.httpClient.get(`${this.environment.FileManagementURL}/manage-outliers/?file_name=${fileName}&user_id=${userId}&version_no=${versionNo}`)
  }

  updateOutlierData(obj = {}) {
    return this.httpClient.post(`${this.environment.FileManagementURL}/manage-outliers/`, obj);
  }

  updateFileStats(obj = {}) {
    return this.httpClient.post(`${this.environment.FileManagementURL}/update-stats/`, obj);
  }

  saveAsNewVersion(obj = {}) {
    return this.httpClient.post(`${this.environment.FileManagementURL}/save-data-version/`, obj);
  }

  fetchVersionDetails(fileName: string, userId: number, versionNo: string | null = '0') {
    return this.httpClient.get(`${this.environment.FileManagementURL}/get-version-details/?file_name=${fileName}&user_id=${userId}&version_no=${versionNo}`)
  }

}
